import { useEffect } from "react";
import { SquaayAndroidLink, SquaayIOSLink } from "../../common/constant";
import "./UserDownloadRedirect.css";

const ANDROID_URL = SquaayAndroidLink;
const IOS_URL = SquaayIOSLink;
const FALLBACK_URL = "/download-options";

const detectDevice = () => {
  const ua = navigator.userAgent || navigator.vendor;

  if (/android/i.test(ua)) return "android";
  if (/iPad|iPhone|iPod/.test(ua)) return "ios";

  return "other";
};

export default function UserDownloadRedirect() {
  useEffect(() => {
    const device = detectDevice();

    if (device === "android") {
      window.location.replace(ANDROID_URL);
    } else if (device === "ios") {
      window.location.replace(IOS_URL);
    } else {
      window.location.replace(FALLBACK_URL);
    }
  }, []);

  return (
    <div className="download-redirect-container">
      <div className="download-redirect-blobs">
        <div className="download-redirect-blob download-redirect-blob-1"></div>
        <div className="download-redirect-blob download-redirect-blob-2"></div>
      </div>

      <div className="download-redirect-content">
        <div className="download-redirect-loading">
          <div className="download-redirect-logo">🍽️</div>
          <div>
            <h2 className="download-redirect-title">Redirecting to App Store</h2>
            <p className="download-redirect-subtitle">
              Taking you to the right place to download Squaay
            </p>
            <div className="status-badge status-loading">REDIRECTING</div>
          </div>
          <div className="download-redirect-spinner">
            <div className="download-redirect-spinner-dot"></div>
            <div className="download-redirect-spinner-dot"></div>
            <div className="download-redirect-spinner-dot"></div>
          </div>
          <p className="download-redirect-message">
            ⏱️ This usually takes just a moment. If nothing happens, you'll be taken to our download page.
          </p>
        </div>
      </div>
    </div>
  );
}